import { createFileRoute } from '@tanstack/react-router';
import PlacesPage from '../../views/dashboard-places';

export const Route = createFileRoute('/dashboard/places/')({
  component: PlacesPage,
});
